<bb-page-header [icon]="'users'" [title]="'USERS' | translate" [filterConfig]="filterConfig"></bb-page-header>

<div class="body-column">
	<!-- <user-details [user]="rows[0].data"></user-details> -->
	<div class="action-buttons">
		<a class="button" [routerLink]="['/publication/users/new']"><i class="fa fa-plus"></i>
			<span class="short-label">{{ 'NEW_USER' | translate }}</span>
			<span class="long-label">{{ 'CREATE_NEW_USER' | translate }}</span>
		</a>
		<a class="button" [ngClass]="{disabled: !putRight}" [href]="mailAllUsers()" target="_blank">
			<i class="fa fa-envelope"></i>
			<span class="short-label">{{ 'MAIL_ALL' | translate }}</span>
			<span class="long-label">{{ 'MAIL_ALL_USERS' | translate }}</span>
		</a>
		<div class="with-selected" [ngClass]="{'has-selected': selectedRows.length > 0}">
			<span *ngIf="!selectedRows || selectedRows.length === 0" class="selected-label">{{ 'NO_USER_SELECTED' |
				translate }}</span>
			<span *ngIf="selectedRows.length > 0" class="selected-label">{{ 'WITH_SELECTED' | translate : {value:
				selectedRows.length} }}:</span>

			<span [ngClass]="{disabled: !putRight || !selectedRows || selectedRows.length === 0}" class="button"
				(click)="duplicateUser(selectedRows[0])">
				<i class="fa fa-copy"></i>{{ 'DUPLICATE' | translate }}
			</span>

			<span [ngClass]="{disabled: !putRight || !selectedRows || selectedRows.length === 0}" class="button"
				(click)="resetPassword(selectedRows[0])">
				<i class="fa fa-refresh"></i>{{ 'RESET_PASSWORD' | translate }}
			</span>
		</div>
	</div>


	<bb-table-container>

		<bb-table-header>
			<bb-table-header-cell property="id" optional>{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="firstname">{{ 'FIRST_NAME' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="lastname">{{ 'LAST_NAME' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="email">{{ 'EMAIL' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="roles">{{ 'ROLES' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="homePublicationLabel">{{ 'PUBLICATION' | translate }}
			</bb-table-header-cell>
			<bb-table-header-cell property="createddate" class="date">{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="updateddate" class="date">{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row">
			<bb-table-cell property="id">{{ row.data.id }}<span
					*ngIf="currentPublicationId && row.data.publicationid && row.data.publicationid !== currentPublicationId"
					[title]="('HOME_PUBLICATION' | translate) + ': ' + row.data.homePublicationLabel">*</span>
			</bb-table-cell>
			<bb-table-cell property="firstname">{{ row.data.firstname }}</bb-table-cell>
			<bb-table-cell property="lastname">{{ row.data.lastname }}</bb-table-cell>
			<bb-table-cell property="email" class="overflow">
				<span>{{ row.data.email }}</span>
			</bb-table-cell>
			<bb-table-cell property="roles" class="overflow">
				<span
					*ngIf="rolesData && row.data.contextRoles && row.data.contextRoles[ 'publication/' + currentPublicationId ]">
					<span
						*ngFor="let roleId of row.data.contextRoles[ 'publication/' + currentPublicationId ]; let i = index">
						{{ rolesData[ 'role' + roleId] }}<span
							[hidden]="row.data.contextRoles[ 'publication/' + currentPublicationId ].length - 1 === i">,
						</span>
					</span>
				</span>
			</bb-table-cell>
			<bb-table-cell property="homePublicationLabel">
				<span [title]="row.data.homePublicationVhost">{{row.data.homePublicationLabel ||
					row.data.homePublicationName}}</span>
			</bb-table-cell>
			<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{
				row.data.createddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}
			</bb-table-cell>
			<bb-table-cell property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">{{
				row.data.updateddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy">{{ row.data.updatedBy }}
			</bb-table-cell>
			<bb-table-cell class="buttons">
				<a class="button with-pointer-events" [routerLink]="['/publication/users/', row.data.id]"
					[ngClass]="{disabled: (currentPublicationId && row.data.publicationid && row.data.publicationid !== currentPublicationId) || row.data.externalId}"
					[title]="(currentPublicationId && row.data.publicationid && row.data.publicationid !== currentPublicationId) ? ('CANNOT_EDIT_USER_IN_THIS_PUBLICATION' | translate:{homePublication:(row.data.homePublicationLabel ? row.data.homePublicationLabel : row.data.homePublicationName)}) : ''">
					<i class="fa fa-edit" (easterEgg)="showData(row.id)"></i>
				</a>
				<a class="button" [ngClass]="{disabled: !putRight}" (click)="deleteSingle(row.data)"
					*ngIf="!(currentPublicationId && row.data.publicationid && row.data.publicationid !== currentPublicationId)">
					<i class="fa fa-trash"></i>
				</a>
				<a class="button" [ngClass]="{disabled: !putRight}" (click)="unlinkUser(row.data)"
					*ngIf="currentPublicationId && row.data.publicationid && row.data.publicationid !== currentPublicationId">
					<i class="fa fa-unlink"></i>
				</a>
				<a class="button root" [hasPublicationField]="'switchUser'" (click)="switchToUser(row.data.email)"
					title="Switch to user">
					<i class="fa fa-user-secret"></i>
				</a>
			</bb-table-cell>
		</bb-table-row>

	</bb-table-container>

	<bb-table-pager></bb-table-pager>

</div>
